import React from 'react';
import { PopupboxManager, PopupboxContainer } from 'react-popupbox';

import LockoutMessage from './LockoutMessage/LockoutMessage';
import WarningMessage from './WarningMessage/WarningMessage';

class LockoutLightbox extends React.Component {
  constructor(props) {
    super(props);

    this.displayPopupbox = this.displayPopupbox.bind(this);
  }

  componentDidMount() {
    const { displayWarningMessage, displayLockoutMessage, userEmail } = this.props;

    if (displayWarningMessage || displayLockoutMessage) {
      this.displayPopupbox(displayWarningMessage, userEmail);
    }
  }

  displayPopupbox(warningMessage, userEmail) {
    PopupboxManager.open({
      content: (
        <div>
          {warningMessage ? <WarningMessage userEmail={userEmail} /> : <LockoutMessage userEmail={userEmail} />}
          <button className="action blue button" onClick={PopupboxManager.close}>
            I understand
          </button>
        </div>
      ),
      config: {
        overlayClose: false,
        titleBar: {
          enable: true,
          text: warningMessage ? 'Account Lockout: Warning' : 'Account Lockout',
        },
      },
    });
  }

  render() {
    const { data } = this.props;
    return <PopupboxContainer />;
  }
}

export default LockoutLightbox;
